/**
 * MEMBERS DASHBOARD V2 — Controller
 * Manages tabs, data hydration, product display, badges, heatmap, pillars, and challenges.
 */
(function () {
    document.addEventListener('DOMContentLoaded', function () {
        // --- ELEMENTS ---
        var shell = document.querySelector('.mdash');
        if (!shell) return;

        var dashView = document.getElementById('DashV2');
        var gateView = document.getElementById('GateV2');
        var softEmail = localStorage.getItem('ashe_student_email');
        var isHardLoggedIn = shell.dataset.customer === 'true';

        // --- GATE / DASHBOARD TOGGLE ---
        if (!isHardLoggedIn && softEmail) {
            if (dashView) dashView.style.display = 'block';
            if (gateView) gateView.style.display = 'none';
            hydrateProfileUI(softEmail);
        } else if (!isHardLoggedIn && !softEmail) {
            if (dashView) dashView.style.display = 'none';
            if (gateView) gateView.style.display = 'block';
        }

        // --- AUTH FORM ---
        var authForm = document.getElementById('GateAuthForm');
        if (authForm) {
            authForm.addEventListener('submit', function (e) {
                e.preventDefault();
                var email = document.getElementById('GateEmailInput').value.trim();
                if (!email) return;
                var btn = authForm.querySelector('button[type=submit]');
                btn.textContent = 'Loading...';
                btn.disabled = true;
                localStorage.setItem('ashe_student_email', email);
                localStorage.setItem('ashe_auth_status', 'authenticated');
                if (window.AsheGamification) {
                    window.AsheGamification.profile.email = email;
                    window.AsheGamification.updateUI();
                    window.AsheGamification.saveProfile();
                }
                if (dashView) dashView.style.display = 'block';
                if (gateView) gateView.style.display = 'none';
                hydrateProfileUI(email);
                btn.textContent = 'Enter Dashboard';
                btn.disabled = false;
            });
        }

        // --- TAB NAVIGATION ---
        var tabs = shell.querySelectorAll('.mdash-tab');
        var panels = shell.querySelectorAll('.mdash-panel');
        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                var target = tab.dataset.tab;
                tabs.forEach(function (t) { t.classList.remove('active'); });
                panels.forEach(function (p) { p.classList.remove('active'); });
                tab.classList.add('active');
                var panel = document.getElementById('panel-' + target);
                if (panel) panel.classList.add('active');
            });
        });

        // --- SIGN OUT ---
        shell.querySelectorAll('[id="DashSignOut"]').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                localStorage.removeItem('ashe_student_email');
                localStorage.removeItem('ashe_auth_status');
                localStorage.removeItem('ashe_auth_v20');
                localStorage.removeItem('ashe_method_profile_v20');
                window.AsheAuthenticated = false;
                window.location.reload();
            });
        });

        // --- PROFILE UI HYDRATION ---
        function hydrateProfileUI(email) {
            shell.querySelectorAll('[data-dash-name]').forEach(function (el) { el.textContent = email; });
            shell.querySelectorAll('[data-dash-email]').forEach(function (el) { el.textContent = email; });
        }

        // --- FIX 2: UNIFIED LEVEL HELPER ---
        function getLevelInfo(xp) {
            xp = xp || 0;
            var level = Math.floor(Math.sqrt(xp / 100)) + 1;
            var currentLevelBase = Math.pow(level - 1, 2) * 100;
            var nextLevelBase = Math.pow(level, 2) * 100;
            var xpInLevel = xp - currentLevelBase;
            var xpNeeded = nextLevelBase - currentLevelBase;
            var percent = Math.min(100, Math.max(0, (xpInLevel / xpNeeded) * 100));
            return { level: level, xpInLevel: xpInLevel, xpNeeded: xpNeeded, percent: percent };
        }

        // --- GAMIFICATION DATA BINDING ---
        function updateDashboard(profile) {
            var fmt = function (n) { return n ? n.toLocaleString() : '0'; };
            setEl('DashXP', fmt(profile.xp));
            setEl('DashCoins', fmt(profile.coins));
            setEl('DashStreak', profile.streak || 0);
            setEl('DashOrderCount', profile.ordersCount || shell.dataset.orders || '0');

            // Fix 2: Unified level formula
            var info = getLevelInfo(profile.xp);
            setEl('DashLevel', 'Level ' + info.level);
            setEl('DashXPProgress', info.xpInLevel + ' / ' + info.xpNeeded + ' XP');
            var fillEl = document.getElementById('DashLevelFill');
            if (fillEl) fillEl.style.width = info.percent + '%';

            // Rank
            var ranks = ['Initiate', 'Seeker', 'Practitioner', 'Scholar', 'Adept', 'Artisan', 'Virtuoso', 'Master', 'Grandmaster', 'Sage'];
            var rankIdx = Math.min(Math.floor((info.level - 1) / 2), 9);
            setEl('DashRank', ranks[rankIdx]);
            setEl('NavRankBadge', ranks[rankIdx]);

            // Fix 1: Real Heatmap
            renderHeatmap(profile);
            // Fix 5: Pillar Progress
            renderPillars(profile);
            // Fix 6: Badges with timestamps
            renderBadges(profile);
            // Fix 4: Weekly challenges
            renderChallenges(profile);
        }

        function setEl(id, val) {
            var el = document.getElementById(id);
            if (el) el.textContent = val;
        }

        window.addEventListener('ashe_profile_updated', function (e) { updateDashboard(e.detail); });
        if (window.AsheGamification && window.AsheGamification.profile) {
            updateDashboard(window.AsheGamification.profile);
        } else {
            setTimeout(function () {
                if (window.AsheGamification && window.AsheGamification.profile) {
                    updateDashboard(window.AsheGamification.profile);
                }
            }, 600);
        }

        // --- FIX 1: REAL HEATMAP ---
        function renderHeatmap(profile) {
            var grid = document.getElementById('DashHeatmap');
            if (!grid) return;
            grid.innerHTML = '';
            var days = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
            var today = new Date();
            var log = profile.activityLog || [];

            // Build a map of date -> total minutes
            var dateMap = {};
            log.forEach(function (entry) { dateMap[entry.date] = (dateMap[entry.date] || 0) + entry.minutes; });

            for (var i = 13; i >= 0; i--) {
                var d = new Date(); d.setDate(today.getDate() - i);
                var dateStr = d.toDateString();
                var isToday = i === 0;
                var minutes = dateMap[dateStr] || 0;
                var hasPractice = minutes > 0;
                var cell = document.createElement('div');
                cell.className = 'hm-cell' + (hasPractice ? ' active' : '') + (isToday ? ' today' : '');
                // Intensity based on minutes: light (< 10), medium (10-30), heavy (30+)
                if (hasPractice) {
                    var opacity = Math.min(1, 0.4 + (minutes / 60) * 0.6);
                    cell.style.background = 'rgba(0,201,219,' + opacity + ')';
                    cell.title = Math.round(minutes) + ' min';
                }
                cell.textContent = days[d.getDay()];
                grid.appendChild(cell);
            }
        }

        // --- FIX 5: PILLAR MAPPING ---
        function renderPillars(profile) {
            var ts = profile.toolStats || {};
            var maxSessions = 50; // 50 sessions = 100%
            var mappings = [
                { id: 'pillar-rhythm', tools: ['metronome', 'rhythm_trainer'] },
                { id: 'pillar-harmony', tools: ['harmony'] },
                { id: 'pillar-melody', tools: ['fretboard'] },
                { id: 'pillar-technique', tools: ['fretboard', 'metronome'] },
                { id: 'pillar-composition', tools: ['idea_state'] },
                { id: 'pillar-tone', tools: ['delay', 'discography'] },
                { id: 'pillar-theory', tools: ['harmony', 'fretboard'] }
            ];
            mappings.forEach(function (m) {
                var el = document.getElementById(m.id);
                if (!el) return;
                var totalSessions = 0;
                m.tools.forEach(function (t) { if (ts[t]) totalSessions += ts[t].sessions; });
                var pct = Math.min(100, Math.round((totalSessions / maxSessions) * 100));
                el.style.width = pct + '%';
            });
        }

        // --- FIX 6: BADGES WITH TIMESTAMPS ---
        function renderBadges(profile) {
            var container = document.getElementById('DashBadgesGrid');
            if (!container) return;
            var earnedMap = {};
            (profile.achievements || []).forEach(function (a) { earnedMap[a.id] = a.earnedAt; });

            var allBadges = [
                { id: 'first_session', icon: '🎸', name: 'First Session', desc: 'Complete your first practice session' },
                { id: 'streak_3', icon: '🔥', name: '3-Day Streak', desc: 'Practice 3 days in a row' },
                { id: 'streak_7', icon: '⚡', name: '7-Day Streak', desc: 'Practice 7 days in a row' },
                { id: 'streak_30', icon: '💎', name: '30-Day Streak', desc: 'Practice 30 days in a row' },
                { id: 'lvl_5', icon: '🏅', name: 'Level 5', desc: 'Reach Level 5' },
                { id: 'lvl_10', icon: '🏆', name: 'Level 10', desc: 'Reach Level 10' },
                { id: 'coins_100', icon: '💰', name: 'Coin Collector', desc: 'Earn 100 Ashe Coins' },
                { id: 'coins_500', icon: '🪙', name: 'Coin Hoarder', desc: 'Earn 500 Ashe Coins' },
                { id: 'tools_3', icon: '🛠️', name: 'Multi-Tool', desc: 'Use 3 different tools' },
                { id: 'xp_1000', icon: '⭐', name: 'XP Legend', desc: 'Earn 1,000 total XP' },
                { id: 'xp_5000', icon: '🌟', name: 'XP Master', desc: 'Earn 5,000 total XP' },
                { id: 'shopper', icon: '🛍️', name: 'Gear Head', desc: 'Purchase from the shop' }
            ];

            container.innerHTML = '';
            allBadges.forEach(function (badge) {
                var earnedAt = earnedMap[badge.id];
                var earned = !!earnedAt;
                var div = document.createElement('div');
                div.className = 'mdash-badge ' + (earned ? 'earned' : 'locked');
                var dateStr = '';
                if (earned && earnedAt) {
                    try { dateStr = new Date(earnedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } catch (e) { dateStr = '✓'; }
                }
                div.innerHTML = '<span class="mdash-badge__icon">' + badge.icon + '</span>' +
                    '<div class="mdash-badge__name">' + badge.name + '</div>' +
                    '<div class="mdash-badge__desc">' + badge.desc + '</div>' +
                    (earned ? '<span class="mdash-badge__date">' + dateStr + '</span>' : '');
                container.appendChild(div);
            });
        }

        // --- FIX 4: WEEKLY CHALLENGES RENDERING ---
        function renderChallenges(profile) {
            var wc = profile.weeklyChallenges;
            if (!wc || !wc.challenges) return;

            var challengeMap = {
                'practice_5_days': 'challenge-practice5',
                'try_new_tool': 'challenge-newtool',
                'streak_7': 'challenge-streak7'
            };

            wc.challenges.forEach(function (ch) {
                var elId = challengeMap[ch.id];
                if (!elId) return;
                var el = document.getElementById(elId);
                if (!el) return;
                // Update progress text
                var progEl = el.querySelector('.mdash-challenge__progress');
                if (progEl) progEl.textContent = ch.progress + '/' + ch.target;
                // Update reward text
                var rewardEl = el.querySelector('.mdash-challenge__reward');
                if (rewardEl && ch.completed) {
                    rewardEl.textContent = '✓ Done';
                    rewardEl.style.color = '#22c55e';
                }
                // Update progress bar
                var barEl = el.querySelector('.mdash-challenge__bar-fill');
                if (barEl) barEl.style.width = Math.min(100, (ch.progress / ch.target) * 100) + '%';
                // Completed state
                if (ch.completed) el.classList.add('completed');
            });
        }

        // --- SETTINGS TOGGLES ---
        shell.querySelectorAll('.mdash-toggle').forEach(function (toggle) {
            toggle.addEventListener('click', function () {
                toggle.classList.toggle('on');
                var key = toggle.dataset.setting;
                if (window.AsheGamification && window.AsheGamification.profile.settings) {
                    window.AsheGamification.profile.settings[key] = toggle.classList.contains('on');
                    window.AsheGamification.saveProfile();
                }
            });
        });
    });
})();
